/* eslint-disable default-case */
import { groupBy, orderBy } from 'lodash'

import { precise_round_to_number } from './amountProcessing'

export const summaryScreenConstants = {
  GENERAL: 'general',
  SURCHARGE: 'surcharge',
  NSW_VOUCHER: 'nsw',
  MEMBERSHIP: 'membership',
  MEMBERSHIP_FORM: 'Membership Form',
  EVENT_FORM: 'Event Form',
  SHOP_FORM: 'Shop Form',
}

// order orgs by finanical level and self is always the first
export function sortVoucherEnabledOrgs(organisationsInfo, currentOrgId, voucherData) {
  // biome-ignore lint/complexity/useOptionalChain: TODO(biome-2.4): newly detected in 2.4 upgrade
  if (!organisationsInfo || !organisationsInfo.length) return []

  let sortOrder = 'desc'

  const { appliedVoucher, voucherId } = voucherData || {}
  const currentOrg = organisationsInfo.find(org => org.sfid === currentOrgId)
  const { voucherConfig } = currentOrg || {}

  if (appliedVoucher && currentOrg && voucherConfig) {
    const currentVoucherConfig = voucherConfig.find(c => c.id === voucherId)
    if (currentVoucherConfig) {
      const { applyRule } = currentVoucherConfig
      switch (applyRule) {
        case 'fromabovetobelow':
          sortOrder = 'asc'
          break
        case 'frombelowtoabove':
          sortOrder = 'desc'
          break
      }
    }
  }

  const orderedOrgs = orderBy(organisationsInfo, ['financialLevel'], [sortOrder]).filter(
    orgInfo => orgInfo.isVoucherEnabled
  )

  return orderedOrgs
}

export function sortItemsByOrgAndPriceName(items) {
  // biome-ignore lint/complexity/useOptionalChain: TODO(biome-2.4): newly detected in 2.4 upgrade
  if (!items || !items.length) return {}
  const itemsByOrgs = groupBy(
    items.filter(item => !!item.grantMemberTypes.find(type => type.isPlayer)),
    item => item.organisation
  )
  const orgsInArray = Object.keys(itemsByOrgs).map(org =>
    orderBy(
      itemsByOrgs[org],
      [
        item => precise_round_to_number((item.discountPrice || item.listPrice) * item.quantity, 2),
        item => item.name.toString().toLowerCase(),
      ],
      ['desc', 'asc']
    )
  )
  /* eslint-disable-next-line prefer-const */
  const orgsInObject = {}

  orgsInArray.forEach(org => {
    orgsInObject[org[0].organisation] = org
  })
  return orgsInObject
}

export const getVoucherError = error => {
  switch (error) {
    case 'Invalid Voucher.':
      return (
        <p style={{ marginBottom: 0 }}>
          <strong>Invalid Voucher Code:</strong> Voucher Code is not Valid
        </p>
      )
    case 'Voucher is no longer available':
    case 'Invalid Pin.':
    case 'Invalid Pin':
      return (
        <p style={{ marginBottom: 0 }}>
          <strong>Invalid Pin:</strong> Your DOB does not match the required DOB to redeem this voucher.
        </p>
      )
    default:
      return error || 'Something went wrong'
  }
}
